export const MACHINE_TYPES = {
  AF: "AF", // Autômato Finito
  AP: "AP", // Autômato de Pilha
  ALL: "ALL", // Autômato Linearmente Limitado
  MT: "MT", // Máquina de Turing
};

export const PDA_ACCEPTANCE_CRITERION = {
  EMPTY_STACK: "EMPTY_STACK",
  FINAL_STATE: "FINAL_STATE",
  DEFAULT: "DEFAULT",
};
